import { render, staticRenderFns } from "./MenuMainSm.vue?vue&type=template&id=3a8cb2d6&scoped=true&"
import script from "./MenuMainSm.vue?vue&type=script&lang=js&"
export * from "./MenuMainSm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cb2d6",
  null
  
)

export default component.exports